module.exports = __webpack_public_path__ + "media/images/crypto/ethereum_small-814e65cf6a06d1032837b16a9954a384.png";